import { RouterConfig } from '@wix/thunderbolt-ssr-api'
import { ViewerModel } from '@wix/thunderbolt-symbols'

export type LightboxEvent = 'popupOpen' | 'popupClose' | 'popupScroll'
export type LightboxEventListener = ((evt?: any) => void) | null | undefined

export interface ILightbox {
	open(lightboxPageId: string, closeHandler?: LightboxEventListener): Promise<void>
	close(): Promise<void>
	isLightbox(pageId: string): boolean
	registerToLightboxEvent(eventType: LightboxEvent, eventHandler: LightboxEventListener): void
	getCurrentLightboxId(): string | undefined
	isOpen(): boolean
}

export interface ICurrentLightbox {
	isDuringReopen(): boolean
}

export interface ILightboxUtils {
	isLightbox(pageId: string): boolean
	getCurrentLightboxId(): string | undefined
	getLightboxPages(): LightboxesMasterPageConfig['popupPages']
}

export interface ILightboxesPageNavigationHandler {
	name: string
	appWillLoadPage(): void
}
export type LightboxFeatureState = {
	pageWillLoadHandler: null | Function
	currentLightboxId: string | undefined
	pendingLightboxId: string | undefined
	pendingLightboxPromise?: Promise<void>
}
export type LightboxesMasterPageConfig = {
	popupPages: {
		[pageId: string]: boolean
	}
	isResponsive: boolean
}

export type LightboxPageConfig = {
	closeSiteButtons: {
		[pageId: string]: boolean
	}
	popupsWithCloseOnOverlayClick: {
		[pageId: string]: boolean
	}
}

export interface ILightboxesAPI {
	addLightboxToDynamicStructure: (lightboxPageId: string) => Promise<void>
	removeLightboxFromDynamicStructure: (lightboxPageId: string) => void
}

export interface ILightboxesResponseHandler {
	handleResponse(
		routerResponsePromise: Promise<Response>
	): Promise<{
		pageId: string | null
	}>
}

export type PageIdToRouterFetchData = {
	[pageId: string]: RouterFetchData
}

export type LightboxSiteConfig = {
	pageIdToRouterFetchData: PageIdToRouterFetchData
	viewMode: ViewerModel['viewMode']
}

export const LightboxesRequestType = 'lightboxes'

// TODO https://jira.wixpress.com/browse/TB-8521

type PageRole = {
	id: string
	title: string
}

export type BodyData = {
	pageRoles: Record<string, PageRole>
	routerPrefix: string
	config: any
	roleVariations: RouterConfig['roleVariations']
}

export type UrlData = {
	basePath: string
	queryParams: string
	appDefinitionId: string
}

export type OptionsData = {
	bodyData: BodyData
	headers: Record<string, string>
	credentials?: RequestInit['credentials']
	mode?: RequestInit['mode']
}

export type RouterFetchData = {
	urlData: UrlData
	optionsData: OptionsData
	wixCodeAppDefinitionId: string
}
